import {
    ActionTypes as HomeActions
} from "./action";

import {
    ActionTypes as SettingActions
} from "./../../components/setting/model";
export const initState = {
    isReady: false,
    isToggleFull: false,
}

export default function handler(state = initState, actions) {
    if (actions.type == HomeActions.CHANGE_APP_STATE) {
        return {
            ...state,
            ...actions.payload
        };
    }

    if(actions.type == SettingActions.CHANGE_SETTING_VALUE && actions.payload.isToggleFull != null) {
        return {
            ...state,
            isToggleFull : actions.payload.isToggleFull
        };
    }

    return state;
}